import { createSlice } from '@reduxjs/toolkit';
import {
    createLiveGuidelineDraftAction,
    getLiveGuidelineByIdAction,
    getLiveGuidelinesListAction,
    hideLiveGuidelineProductAction,
    restoreLiveGuidelineProductAction,
} from '../../actions/liveGuidelineActions';

export interface LiveGuidelineReducerType {
    pending: boolean;
    createPending: boolean;
    productsChangedAt: number;
}

const initialState: LiveGuidelineReducerType = {
    pending: false,
    createPending: false,
    productsChangedAt: 0,
};

export const liveGuidelineSlice = createSlice({
    name: 'liveGuidelines',
    initialState,
    reducers: {
        // Reuses the same signal hide/restore bump below, so ProductsTab/NotificationsTab/
        // LiveGuidelineDetail refetch after a background TC sync completes - no full page reload needed.
        markLiveGuidelineProductsChanged: (state) => {
            state.productsChangedAt = Date.now();
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getLiveGuidelinesListAction.pending, (state) => {
            state.pending = true;
        });
        builder.addCase(getLiveGuidelinesListAction.fulfilled, (state) => {
            state.pending = false;
        });
        builder.addCase(getLiveGuidelinesListAction.rejected, (state) => {
            state.pending = false;
        });
        builder.addCase(getLiveGuidelineByIdAction.pending, (state) => {
            state.pending = true;
        });
        builder.addCase(getLiveGuidelineByIdAction.fulfilled, (state) => {
            state.pending = false;
        });
        builder.addCase(getLiveGuidelineByIdAction.rejected, (state) => {
            state.pending = false;
        });
        builder.addCase(createLiveGuidelineDraftAction.pending, (state) => {
            state.pending = true;
            state.createPending = true;
        });
        builder.addCase(createLiveGuidelineDraftAction.fulfilled, (state) => {
            state.pending = false;
            state.createPending = false
        });
        builder.addCase(createLiveGuidelineDraftAction.rejected, (state) => {
            state.pending = false;
            state.createPending = false
        });
        // Bumped so ProductsTab/NotificationsTab can refetch after a hide/restore action.
        const bumpProductsChanged = (state: LiveGuidelineReducerType) => {
            state.productsChangedAt = Date.now();
        };
        builder.addCase(hideLiveGuidelineProductAction.fulfilled, bumpProductsChanged);
        builder.addCase(restoreLiveGuidelineProductAction.fulfilled, bumpProductsChanged);
    },
});

export default liveGuidelineSlice.reducer;
export const { markLiveGuidelineProductsChanged } = liveGuidelineSlice.actions;
